
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TheMiniLoader extends Vue {
  @Prop()
  loading!: boolean
}
